import { SectionTabsLayout, type SectionTabItem } from "./section-tabs-layout";

const REVENUE_TABS: SectionTabItem[] = [
  {
    label: "Overview",
    to: "/revenue",
    // Exact, not a prefix: every other tab under Revenue lives below /revenue.
    match: (pathname) => pathname === "/revenue",
  },
  {
    // Promo codes is a tab of Revenue rather than a sidebar section of its
    // own: a code is a discount on a subscription payment, so it moves the
    // same MRR the Overview tab reports, and it is one page with nothing
    // under it.
    label: "Promo codes",
    to: "/revenue/promo-codes",
    match: (pathname) => pathname.startsWith("/revenue/promo-codes"),
  },
];

export function RevenueLayout() {
  return <SectionTabsLayout id="revenue" items={REVENUE_TABS} />;
}
